import { Heading } from '../../Heading/Heading';
import { Text } from '../../Text/Text';

interface IProps {
  cardDescription?: string;
}

export const EmptyCatchInfoCard = ({ cardDescription }: IProps) => {
  const availabilityText = 'Data unavailable';

  return (
    <div
      className="bg-lake-fog flex flex-col justify-between rounded-md p-2"
      data-testid="catch-info-card"
    >
      <header>
        <Heading as="h3" className="mx-auto mb-0 text-center" variant="2xs">
          {availabilityText}
        </Heading>
      </header>
      <Text variant="sm" className="text-trench mb-0 px-2 text-center">
        {cardDescription}
      </Text>
    </div>
  );
};
